import { render, staticRenderFns } from "./claimCount.vue?vue&type=template&id=97961e28&scoped=true"
import script from "./claimCount.vue?vue&type=script&lang=js"
export * from "./claimCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97961e28",
  null
  
)

export default component.exports